var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapContainer"},[_c('Header',{attrs:{"menu-list":_vm.menuTop,"title":_vm.title},on:{"doDrop":_vm.handleDrop}}),_vm._v(" "),_c('div',{staticClass:"homeContainer"},[_c('router-view',{on:{"setTitle":_vm.setTitle}})],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('Share',{attrs:{"type":'share'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab71480","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/phoneHome/main.vue
// module id = null
// module chunks = 